export function createOptions(data: readonly string[] | null | undefined) {
  if (!data) {
    return [];
  }
  return data.map(category => ({
    id: category,
    label: category,
  }));
}
